import { useMemo } from "react";
import { useCalculation } from "../context";
import { getInNamespaced, isVariableField } from "../../calculator/utils";
import { useFieldData, useFieldsData } from "./useFieldData";
import { useVariableData, useVariablesData } from "./useVariableData";
import { fieldDef } from "./fieldDef";
export function getFieldVariableName({ fieldControlMaps, controlFieldMaps }, namespace, name) {
    const controlRef = getInNamespaced(fieldControlMaps, namespace, name);
    const resolveInfo = getInNamespaced(controlFieldMaps, namespace, controlRef);
    return isVariableField(resolveInfo) ? resolveInfo.variable : undefined;
}
export function useCalculationField(namespaceOrField, fieldName) {
    const { namespace, name } = fieldDef(namespaceOrField, fieldName) ?? {};
    const { fieldControlMaps, controlFieldMaps } = useCalculation("fieldControlMaps", "controlFieldMaps");
    const variableName = getFieldVariableName({ fieldControlMaps, controlFieldMaps }, namespace, name);
    const fieldData = useFieldData(name != null ? { namespace, name } : undefined);
    const variableData = useVariableData(namespace, variableName || "");
    const fieldCalculationState = useMemo(() => ({ ...fieldData, ...variableData }), [fieldData, variableData]);
    return fieldCalculationState;
}
export function useCalculationFields(...fields) {
    const { fieldControlMaps, controlFieldMaps } = useCalculation("fieldControlMaps", "controlFieldMaps");
    const variableFields = fields.map(({ namespace, name }) => {
        const variableName = getFieldVariableName({ fieldControlMaps, controlFieldMaps }, namespace, name);
        return { namespace, variableName: variableName || "", name };
    });
    const fieldsData = useFieldsData(...variableFields);
    const variablesData = useVariablesData(...variableFields);
    const data = fieldsData.map((fieldData, i) => {
        const variableData = variablesData[i];
        return fieldData
            ? {
                ...fieldData,
                ...variableData
            }
            : undefined;
    });
    return data;
}
export function useWriteLockedFields(...fields) {
    const { fieldControlMaps, controlFieldMaps, isWriteLocked, isEnabled } = useCalculation("fieldControlMaps", "controlFieldMaps", "isWriteLocked", "isEnabled");
    const variableFields = fields
        .filter(({ namespace, name }) => getInNamespaced(isEnabled, namespace, name) !== false)
        .map(({ namespace, name }) => {
        const variableName = getFieldVariableName({ fieldControlMaps, controlFieldMaps }, namespace, name);
        return { namespace, variableName: variableName || "", name };
    });
    const data = variableFields.map((variableData, i) => ({
        ...variableData,
        writeLocked: getInNamespaced(isWriteLocked, variableData.namespace, variableData.variableName)
    }));
    return data;
}
//# sourceMappingURL=useCalculationField.js.map